function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uF4CF");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar---Filters",
  transform: "translate(-969.000000, -519.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "7.-Small-Components/7.4-Labels-and-Pills/Pills/Filters/Unselected-Copy-9",
  transform: "translate(955.000000, 512.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Small/Solid/Gray",
  transform: "translate(8.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.87499553,5.75001967 C7.4960878,5.75001967 7.99999285,5.24611462 7.99999285,4.62502235 C7.99999285,4.00393008 7.4960878,3.50002503 6.87499553,3.50002503 C6.25390326,3.50002503 5.74999821,4.00393008 5.74999821,4.62502235 C5.74999821,5.24611462 6.25390326,5.75001967 6.87499553,5.75001967 Z M8.49920583,15.4882777 C8.90702651,15.4203 9.18358378,15.0335821 9.11560603,14.6257843 L8.78514723,12.4578208 C8.72655362,12.1109512 8.5484382,11.7945457 8.28124218,11.5648404 L7.24999464,10.6812671 L7.24999464,8.84609688 L8,10.2500089 L13.6249794,10.2500089 C13.8312244,10.2500089 13.9999785,10.0812548 13.9999785,9.87500983 L13.9999785,6.12501878 C13.9999785,5.91641637 13.8312244,5.75001967 13.6249794,5.75001967 L9.87498838,5.75001967 C9.66874345,5.75001967 9.49998927,5.91877384 9.49998927,6.12501878 L9.49998927,8.75001967 L8.90466904,8.75001967 L8.12420672,7.30158305 C7.86406025,6.80703924 7.35546313,6.50001788 6.79765654,6.50001788 L6.12499732,6.50001788 C5.50390505,6.50001788 5,7.00392293 5,7.6250152 L5,10.0390719 C5,10.4773567 5.19219162,10.8922041 5.5250079,11.1781226 L7.30625366,12.7039139 L7.63671246,14.8718775 C7.66014991,15.0054755 7.87342149,15.5914116 8.49920583,15.4882777 Z M5.74999821,15.4976618 C6.16484555,15.4976618 6.5,15.1624881 6.5,14.7476636 L6.5,13.001574 C6.3676438,12.8882455 6.14361638,12.6955048 5.90849476,12.4930094 L5.67265954,12.2898424 C5.32231301,11.9879542 5.00743999,11.7163612 5,11.7101571 L5,14.7476636 C5,15.1624881 5.33515087,15.4976618 5.74999821,15.4976618 Z",
  id: "\\uF4CF"
}))))));

var SvgCarryInIconFiltersSelected = function SvgCarryInIconFiltersSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarryInIconFiltersSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CarryInIconFiltersSelected.e846a1c7.svg";
export { ForwardRef as ReactComponent };